import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-papi-types';
import { actionKey } from '../constants';
import { ArtsAndCraftsDeviationFormFields } from '../../modals/ArtsAndCraftsDeviationPopup/types';

export const createArtsAndCraftsDeviation = createAction(
  `${actionKey}.CREATE_ARTS_AND_CRAFTS_DEVIATION`,
  (payload: {
    formData: ArtsAndCraftsDeviationFormFields;
    onSuccess?: (deviation: PapiDeviation) => void;
    onError?: (response: any) => void;
  }) => payload
);

export const updateArtsAndCraftsDeviation = createAction(
  `${actionKey}.UPDATE_ARTS_AND_CRAFTS_DEVIATION`,
  (payload: {
    deviationId: number;
    formData: ArtsAndCraftsDeviationFormFields;
    onSuccess?: (deviation: PapiDeviation) => void;
    onError?: (response: any) => void;
  }) => payload
);

export const publishArtsAndCraftsDeviation = createAction(
  `${actionKey}.PUBLISH_ARTS_AND_CRAFTS_DEVIATION`,
  (payload: { deviationId: number; onSuccess?: () => void; onError?: (response: any) => void }) =>
    payload
);

export const editArtsAndCraftsDeviation = createAction(
  `${actionKey}.EDIT_ARTS_AND_CRAFTS_DEVIATION`,
  (payload: { deviationId: number }) => payload
);
